<template>
  <div>
    <v-row>
      <v-col cols="12">
        <p class="text-h5 font-weight-bold primary--text px-2 px-md-5" ref="evaluaciones">
          Evaluaciones
        </p>
      </v-col>
    </v-row>
    <v-row
      :justify="puedeModificarUnidad || puedeModificarLey ? 'end' : 'center'"
    >
      <v-col cols="12" v-if="puedeModificarUnidad || puedeModificarLey" class="px-4 px-md-8">
        <div ref="formEvaluacionRow">
        <v-row>
          <v-col cols="12" md="6">
            <v-select
              v-model="formEvaluacion.tipoEvaluacion"
              class="rounded-xl"
              label="Tipo de evaluación*"
              outlined
              :items="tipoEvaluacionOptions"
              item-text="nombre"
              return-object
              :menu-props="{ top: false, offsetY: true }"
              @change="onTipoEvaluacionChange"
              @blur="$v.formEvaluacion.tipoEvaluacion.$touch()"
              :error-messages="tipoEvaluacionErrors"
              :readonly="isReadonly || isView"
              :disabled="isReadonly"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="formEvaluacion.nombreEvaluacion"
              class="rounded-xl"
              label="Nombre de la evaluación a realizar*"
              outlined
              :items="nombreEvaluacionOptions"
              item-text="nombre"
              return-object
              :menu-props="{ top: false, offsetY: true }"
              @blur="$v.formEvaluacion.nombreEvaluacion.$touch()"
              :error-messages="nombreEvaluacionErrors"
              :readonly="isReadonly || isView"
              :disabled="isReadonly || !formEvaluacion.tipoEvaluacion"
            ></v-select>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="formEvaluacion.porcentajePrueba"
              class="inputStyle rounded-xl"
              label="Porcentaje a aplicar a la prueba*"
              outlined
              maxlength="3"
              @keypress="restrictInteger"
              @paste="onPasteInteger"
              @blur="$v.formEvaluacion.porcentajePrueba.$touch()"
              :error-messages="porcentajePruebaErrors"
              :readonly="(!enFaseRRHH && !enFaseUnidad) || isView"
              :disabled="!enFaseRRHH && !enFaseUnidad"
              required
              type="text"
              inputmode="numeric"
              min="0.01"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="formEvaluacion.descripcion"
              class="rounded-xl"
              outlined
              label="Descripción*"
              @blur="$v.formEvaluacion.descripcion.$touch()"
              :error-messages="descripcionErrors"
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <v-row justify="center" no-gutters>
              <v-btn
                color="primary"
                rounded
                :disabled="isView"
                depressed
                @click="actionEvaluacion"
                style="text-transform: none; width: 100px"
                >{{ textBtn(rol) }}</v-btn
              >
              <v-btn
                v-if="textBtn(rol) == 'Actualizar'"
                class="ml-5"
                color="primary"
                outlined
                rounded
                :disabled="isView"
                depressed
                @click="clearFormEva"
                style="width: 100px; text-transform: none"
                >Cancelar</v-btn
              >
            </v-row>
          </v-col>
        </v-row>
        </div>
      </v-col>
      <v-col cols="12" class="px-sm-3 px-1">
        <div class="pa-4">
          <TablaTabs
          :headers="processedHeaders"
          :data="evaluacion"
          :por_pagina="por_pagina"
          :page="pagina"
          :total-registros="totalRegistros"
          :key-id="'id'"
          :slots-column="['nombre', 'id_tipo_evaluacion', 'porcentaje_relativo', 'porcentaje_total', 'action']"
          :rol="rol"
          @paginationChange="changePagina"
          @perPageChange="setPerPageEvaluaciones"
          >
            <template #nombre="{ item }">
              <div
                class="py-3"
                style="word-wrap: break-word"
                :style="
                  $vuetify.breakpoint.name !== 'xs'
                    ? 'max-width: 40vw;'
                    : 'max-width: 50vw;'
                "
              >
                {{ item.nombre }}
              </div>
            </template>
            <template #id_tipo_evaluacion="{ item }">
              <td class="text-center">
                {{ item.ley !== true ? tipoEvaluacionNombre(item) : "-" }}
              </td>
            </template>
            <template #porcentaje_relativo="{ item }">
              <td class="text-center">
                {{ item.porcentaje_relativo }}
              </td>
            </template>
            <template #porcentaje_total="{ item }">
              <td class="text-center">
                {{
                  item.ley !== true ? item.porcentaje_total : item.porcentaje
                }}
              </td>
            </template>
            <template #action="{ item }">
              <v-row class="d-flex justify-start" no-gutters>
                <v-col
                  v-if="puedeModificarUnidad || (item.agregado_rrhh && esFaseActivaUsuario && fasesRh.includes(faseActual))"
                  cols="auto"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on" color="primary" @click="editarItem(item)">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span> Editar </span>
                  </v-tooltip>
                </v-col>
                <v-col
                  v-if="solicitud?.estado_fase_solicitud?.nombre?.toLowerCase() !== 'borrador'"
                  cols="auto"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on" color="primary" @click="verDetalle(item)">
                        <v-icon>mdi-eye-outline</v-icon>
                      </v-btn>
                    </template>
                    <span> Ver </span>
                  </v-tooltip>
                </v-col>
                <v-col
                  v-if="puedeModificarUnidad || (item.agregado_rrhh && esFaseActivaUsuario && fasesRh.includes(faseActual))"
                  cols="auto"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on" color="primary" @click="deleteItem(item)">
                        <v-icon>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </template>
                    <span> Eliminar </span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </template>
          </TablaTabs>
        </div>
      </v-col>
      <Dialogo
        :visible="dialogShow"
        @close="closeDialog"
        @guardar="eliminarItem"
        title="Eliminar evaluación"
        label="¿Desea eliminar la evaluación seleccionada?"
        label-btn="Eliminar"
      />
      <app-dialog
        v-model="showDescripcionDialog"
        title="Descripción de la evaluación"
      >
        <template #body>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="descripcionSeleccionada"
                  class="rounded-xl"
                  outlined
                  readonly
                  no-resize
                  rows="6"
                />
              </v-col>
            </v-row>
          </v-container>
        </template>
        <template #actions>
          <v-row justify="center" class="mb-4">
            <v-btn
              color="primary"
              class="rounded-xl"
              style="text-transform: none"
              outlined
              @click="showDescripcionDialog = false"
            >
              Volver
            </v-btn>
          </v-row>
        </template>
      </app-dialog>
    </v-row>
  </div>
</template>

<script>
import {
  maxValue,
  minValue,
  numeric,
  required,
  requiredIf,
  maxLength
} from "vuelidate/lib/validators";
import AppPagination from "../../../components/ComponentPaginationProcess.vue";
import TablaTabs from "../../../components/TablaTabs.vue";
import Dialogo from "../../../components/Dialogo.vue";
import { mapMutations, mapState } from "vuex";

export default {
  name: "Evaluaciones",
  components: { Dialogo, AppPagination, TablaTabs },
  props: {
    rol: {
      type: String,
      required: true,
      default: () => "unidad"
    },
    idSoli: {
      type: Number,
      default: () => 7
    }
  },
  validations() {
    const notEmojis = (value) => {
      if (!value) return false;
      const x = value.match(
        /(\p{Emoji_Presentation}|\p{Extended_Pictographic})/gu
      );
      if (x != null) {
        return false;
      } else {
        return true;
      }
    };
    const esAlphanumericoConTildes = (value) => {
      if (!value) return false;
      const regex = /[^a-zA-ZáéíóúüÁÉÍÓÚÜñÑ\s]/;
      return !regex.test(value);
    };
    const esAlphanumericoyCaracterEspecial = (value) => {
      if (!value) return false;
      const regex =
        /[^a-zA-Z0-9áéíóúüÁÉÍÓÚÜñÑ\s!@#$%^&*()_\-+=<>?,.;:/[\]{}|\\'"`~`¡¿+-¯´¨©®¯±°-]/;
      return !regex.test(value);
    };
    return {
      formEvaluacion: {
        tipoEvaluacion: {
          required
        },
        nombreEvaluacion: {
          required
        },
        porcentajePrueba: {
          required,
          numeric,
          minValue: minValue(1),
          maxValue: maxValue(100)
        },
        descripcion: {
          required,
          notEmojis,
          esAlphanumericoyCaracterEspecial,
          maxLength: maxLength(500)
        }
      }
    };
  },
  data() {
    return {
      numPage: 10,
      formEvaluacion: {
        tipoEvaluacion: null,
        nombreEvaluacion: null,
        porcentajePrueba: null,
        descripcion: null
      },
      headers: [
        {
          text: "Prueba a realizar",
          align: "left",
          value: "nombre",
          class: "black--text py-5 font-weight-bold text-subtitle-2",
          sortable: false
        },
        {
          text: "Tipo",
          value: "id_tipo_evaluacion",
          align: "center",
          class: "black--text py-5 font-weight-bold text-subtitle-2",
          sortable: false
        },
        {
          text: "Porcentaje unidad(%)",
          value: "porcentaje_relativo",
          align: "center",
          class: "black--text py-5 font-weight-bold text-subtitle-2",
          sortable: false
        },
        {
          text: "Porcentaje RRHH(%)",
          value: "porcentaje_total",
          align: "center",
          class: "black--text py-5 font-weight-bold text-subtitle-2",
          sortable: false
        },
        {
          text: "Acciones",
          value: "action",
          align: "center",
          class: "black--text py-5 font-weight-bold text-subtitle-2",
          sortable: false,
          width: "15%"
        }
      ],
      tipoEvaluacionOptions: [],
      nombreEvaluacionOptions: [],
      evaluacion: [],
      counter: 1,
      por_pagina: 10,
      pagina: 1,
      totalRegistros: 0,
      item: null,
      dialogShow: false,
      action: null,
      isView: true,
      puedeModificarLey: false,
      puedeModificarUnidad: false,
      showDescripcionDialog: false,
      descripcionSeleccionada: ""
    };
  },
  methods: {
    ...mapMutations("utils", ["setLoader"]),
    async init() {
      await Promise.all([
        this.getEvaluacion(),
        this.getTipoEvaluacionOptionsList()
      ]);
      this.numPage = this.pagina;
    },
    async getTipoEvaluacionOptionsList() {
      const response = await this.services.catalogos.getTipoEvaluacionCatalogo();
      this.tipoEvaluacionOptions = Array.isArray(response?.data)
        ? response.data
        : [];
    },
    async getNombreEvaluacionOptionsList(idTipoEvaluacion, idSolicitud) {
      const response = await this.services.catalogos.getEvaluacionPorTipoCatalogo(idTipoEvaluacion, idSolicitud);
      this.nombreEvaluacionOptions = Array.isArray(response?.data)
        ? response.data
        : [];
    },
    tipoEvaluacionNombre(item) {
      const match = this.tipoEvaluacionOptions.find(
        (o) => o.id === item.id_tipo_evaluacion
      );
      return match ? match.nombre : item.id_tipo_evaluacion;
    },
    async onTipoEvaluacionChange(tipoEvaluacion) {
      this.formEvaluacion.nombreEvaluacion = null;
      this.nombreEvaluacionOptions = [];
      if (tipoEvaluacion?.id) {
        await this.getNombreEvaluacionOptionsList(tipoEvaluacion.id, this.$route.params.id);
      }
    },
    deleteItem(item) {
      this.item = item;
      this.action = "borrar";
      this.dialogShow = true;
    },
    verDetalle(item) {
      this.descripcionSeleccionada = item?.descripcion ?? "";
      this.showDescripcionDialog = true;
    },
    closeDialog() {
      this.dialogShow = false;
    },
    async eliminarItem() {
      this.setLoader(true);
      const response = await this.services.catalogos.deleteEvaluacion(
        this.item.id,
        { rrhh: this.enFaseRRHH ? "true" : "false" }
      );
      if (response.status === 200) {
        this.setLoader(false);
        this.temporalAlert({
          show: true,
          message: response.data.message || "Se eliminó con éxito",
          type: "success"
        });
      }
      this.getEvaluacion();
      this.dialogShow = false;
      this.clearFormEva();
      this.setLoader(false);
    },
    // addCorrelativo(item) {
    //   item.num = this.counter++;
    //   return item;
    // },
    clearFormEva() {
      this.formEvaluacion.tipoEvaluacion = null;
      this.formEvaluacion.nombreEvaluacion = null;
      this.formEvaluacion.porcentajePrueba = null;
      this.formEvaluacion.descripcion = null;
      this.nombreEvaluacionOptions = [];
      this.$v.formEvaluacion.$reset();
      this.item = null;
    },
    async guardarEvaluacion() {
      this.$v.formEvaluacion.$touch();
      if (!this.$v.formEvaluacion.$invalid) {
        this.setLoader(true);
        const form = {
          id_solicitud: Number(this.$route.params.id),
          activo: true,
          id_evaluacion: this.formEvaluacion.nombreEvaluacion?.id,
          nombre: this.formEvaluacion.nombreEvaluacion?.nombre,
          porcentaje_relativo: this.enFaseUnidad
            ? Number(Number(this.formEvaluacion.porcentajePrueba))
            : 0,
          porcentaje_total: this.enFaseRRHH
            ? Number(Number(this.formEvaluacion.porcentajePrueba))
            : 0,
          descripcion: this.formEvaluacion.descripcion,
          rrhh: this.enFaseRRHH
        };
        const response = await this.services.catalogos.postEvaluacion(form);
        if (response?.status === 201) {
          this.temporalAlert({
            show: true,
            message: typeof response.data === "string" ? response.data : "Evaluación creada con éxito",
            type: "success"
          });
          this.clearFormEva();
          await this.getEvaluacion();
        }
        this.setLoader(false);
      }
    },
    async actualizarEvaluacion() {
      this.$v.formEvaluacion.$touch();
      if (!this.$v.formEvaluacion.$invalid) {
        if (!this.item) {
          this.temporalAlert({
            show: true,
            message: "Seleccione una evaluación para actualizar",
            type: "warning"
          });
          return;
        }

        this.setLoader(true);
        const body = {
          id_evaluacion: this.formEvaluacion.nombreEvaluacion?.id,
          nombre: this.formEvaluacion.nombreEvaluacion?.nombre,
          descripcion: this.formEvaluacion.descripcion,
          porcentaje_total: this.enFaseRRHH
            ? Number(this.formEvaluacion.porcentajePrueba)
            : 0,
          porcentaje_relativo: this.enFaseUnidad
            ? Number(this.formEvaluacion.porcentajePrueba)
            : 0,
          unidad: this.enFaseUnidad,
          evaluacionley: this.item.ley === true ? true : false,
          rrhh: this.enFaseRRHH
        };
        const response = await this.services.catalogos.putEvaluacion(this.item.id, body);      
        if (response?.status === 200) {
          this.temporalAlert({
            show: true,
            message: response.data?.message || "Evaluación actualizada con éxito",
            type: "success"
          });
          this.clearFormEva();
          await this.getEvaluacion();
        }
        this.setLoader(false);
      }
    },

    async actionEvaluacion() {
      if (this.isView) return;
      if (!this.enFaseRRHH && !this.enFaseUnidad) return;

      if (this.item) {
        await this.actualizarEvaluacion();
      } else {
        await this.guardarEvaluacion();
      }
    },
    async getEvaluacion() {
      const params = {
        pagina: this.pagina,
        cantidad_por_pagina: this.por_pagina
      };
      const { data } = await this.services.catalogos.getEvaluaciones(
        this.$route.params.id,
        params
      );
      let evaluaciones = data.evaluaciones;

      const evaluacionesFinal = evaluaciones.map((e) => {
        if (e.porcentaje_relativo == 0) {
          e.porcentaje_relativo = null;
        }

        return e;
      });

      for (let i = 0; i < evaluaciones.length; i++) {
        const objeto = evaluaciones[i];
        this.$set(objeto, "ley", false);

        if ("nombre_evaluacion_ley" in objeto) {
          // Agregamos la propiedad con el nuevo nombre "nombre"
          this.$set(objeto, "nombre", objeto.nombre_evaluacion_ley);

          // Modificamos la propiedad ley para identificarla
          this.$set(objeto, "ley", true);

          // Eliminamos la propiedad con el nombre antiguo
          delete objeto["nombre_evaluacion_ley"];
        }
      }

      this.evaluacion = evaluacionesFinal;
      this.pagina = Number(data.meta.pagina);
      this.por_pagina = Number(data.meta.cantidad_por_pagina);
      this.totalRegistros = Number(data.meta.totalEvaluaciones);
    },
    // numItem(index) {
    //   const numero = this.por_pagina * (this.pagina - 1) + index;
    //   return numero;
    // },
    async editarItem(item) {
      this.item = item;
      this.action = "editar";
      const tipoExistente = this.tipoEvaluacionOptions.find(
        (o) => o.id === item.id_tipo_evaluacion
      );
      this.formEvaluacion.tipoEvaluacion = tipoExistente || (item.id_tipo_evaluacion
        ? { id: item.id_tipo_evaluacion, nombre: this.tipoEvaluacionNombre(item) }
        : null);
      this.formEvaluacion.nombreEvaluacion = {
        id: item.id_formulario_evaluacion,
        nombre: item.nombre
      };
      this.nombreEvaluacionOptions = [this.formEvaluacion.nombreEvaluacion];
      if (this.enFaseUnidad) {
        this.formEvaluacion.porcentajePrueba = Number(item.porcentaje_relativo);
      } else if (this.enFaseRRHH) {
        if (item.ley !== true) {
          this.formEvaluacion.porcentajePrueba = Number(item.porcentaje_total);
        } else {
          this.formEvaluacion.porcentajePrueba = Number(item.porcentaje);
        }
      }
      this.formEvaluacion.descripcion = item.descripcion;
      
      // Scroll to form
      this.$nextTick(() => {
        if (this.$refs.formEvaluacionRow) {
          this.$refs.formEvaluacionRow.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      });
    },
    textBtn(_rol) {
      return this.item ? "Actualizar" : "Agregar";
    },
    onPasteInteger(evt) {
      let pasted = evt.clipboardData.getData("text");

      let regex = /^[0-9]+$/g.test(pasted);
      if (regex == false) {
        evt.preventDefault();
      }

      if (
        pasted.match(/(\p{Emoji_Presentation}|\p{Extended_Pictographic})/gu)
      ) {
        evt.preventDefault();
      }
    },
    async changePagina(pagina) {
      this.pagina = pagina;
      await this.getEvaluacion();
    },
    async setPerPageEvaluaciones(perPage) {
      this.por_pagina = perPage;
      this.pagina = 1;
      await this.getEvaluacion();
    },
    isPorcentajeTotalValido() {
      return this.totalPorcentaje;
    }
  },
  computed: {
    ...mapState("solicitud", [
      "solicitud",
      "faseActual",
      "esFaseActivaUsuario",
      "fasesRh",
      "fasesUnidad"
    ]),
    processedHeaders() {
      return this.headers.map(header => {
        const headerAlign = header['header-align'] || 'center'
        return {
          ...header,
          class: `${header.class || ''} header-align-${headerAlign}`.trim()
        }
      })
    },
    // modifiedTableData() {
    //   return this.desserts.map(this.addCorrelativo);
    // },
    exceptUnidad() {
      return !this.enFaseUnidad;
    },
    exceptEvaluacion() {
      return !(this.enFaseUnidad || this.enFaseRRHH);
    },
    isReadonly() {
      if (this.enFaseRRHH) {
        if (this.item !== null) {
          if (this.item.hasOwnProperty("agregado_rrhh")) {
            return this.exceptEvaluacion || this.item.agregado_rrhh !== true;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else if (this.enFaseUnidad) {
        return this.exceptEvaluacion;
      } else {
        return true;
      }
    },
    total() {
      return Math.ceil(this.totalRegistros / this.por_pagina);
    },
    totalPorcentaje() {
      if (this.enFaseUnidad) {
        if (this.item && this.action === "editar") {
          return (
            this.evaluacion.reduce((total = 0, item) => {
              if (item.ley !== true) {
                return total + Number(item.porcentaje_relativo);
              }
            }, 0) - this.item.porcentaje_relativo
          );
        } else {
          return this.evaluacion.reduce((total = 0, item) => {
            if (item.ley !== true) {
              return total + Number(item.porcentaje_relativo);
            }
          }, 0);
        }
      } else if (this.enFaseRRHH) {
        if (this.item && this.action === "editar") {
          if (this.item.ley !== true) {
            return (
              this.evaluacion.reduce((total = 0, item) => {
                if (item.ley !== true) {
                  return total + Number(item.porcentaje_total);
                } else {
                  return total + Number(item.porcentaje);
                }
              }, 0) - this.item.porcentaje_total
            );
          } else {
            return (
              this.evaluacion.reduce((total = 0, item) => {
                if (item.ley !== true) {
                  return total + Number(item.porcentaje_total);
                } else {
                  return total + Number(item.porcentaje);
                }
              }, 0) - this.item.porcentaje
            );
          }
        } else {
          return this.evaluacion.reduce((total = 0, item) => {
            if (item.ley !== true) {
              return total + Number(item.porcentaje_total);
            } else {
              return total + Number(item.porcentaje);
            }
          }, 0);
        }
      }
    },
    enFaseRRHH() {
      return this.fasesRh.includes(this.faseActual);
    },
    enFaseUnidad() {
      const cumpleFaseUnidad = this.fasesUnidad.includes(this.faseActual);
      const rutaVer = this.$route.name.includes("solicitud-view");
      return cumpleFaseUnidad && !rutaVer;
      //return this.fasesUnidad.includes(this.faseActual);
    },
    tipoEvaluacionErrors() {
      const errors = [];
      if (!this.$v.formEvaluacion.tipoEvaluacion.$dirty) return errors;
      !this.$v.formEvaluacion.tipoEvaluacion.required &&
        errors.push("Tipo de evaluación es obligatorio");
      return errors;
    },
    nombreEvaluacionErrors() {
      const errors = [];
      if (!this.$v.formEvaluacion.nombreEvaluacion.$dirty) return errors;
      !this.$v.formEvaluacion.nombreEvaluacion.required &&
        errors.push("Nombre de la evaluación es obligatorio");
      return errors;
    },
    porcentajePruebaErrors() {
      const errors = [];
      if (!this.$v.formEvaluacion.porcentajePrueba.$dirty) return errors;
      !this.$v.formEvaluacion.porcentajePrueba.required &&
        errors.push("Porcentaje es obligatorio");
      !this.$v.formEvaluacion.porcentajePrueba.numeric &&
        errors.push("Porcentaje solo debe contener números");
      !this.$v.formEvaluacion.porcentajePrueba.minValue &&
        errors.push("El valor tiene que ser mayor que 0");
      !this.$v.formEvaluacion.porcentajePrueba.maxValue &&
        errors.push("El valor tiene que ser menor que 100");
      // !this.$v.formEvaluacion.porcentajePrueba.isComplete && errors.push("El valor se excede del porcentaje total");
      return errors;
    },
    descripcionErrors() {
      const errors = [];
      if (!this.$v.formEvaluacion.descripcion.$dirty) return errors;
      !this.$v.formEvaluacion.descripcion.required &&
        errors.push("Descripción es obligatorio");
      !this.$v.formEvaluacion.descripcion.maxLength &&
        errors.push("Máximo 500 caracteres");
      !this.$v.formEvaluacion.descripcion.esAlphanumericoyCaracterEspecial &&
        errors.push("Ingreso un caracter no permitido");
      return errors;
    }
  },
  watch: {
    desserts: {
      handler(newItems) {
        // Realizar acciones cuando el array 'items' cambie
      },
      deep: true // Observar cambios profundos en los objetos del array
    },
    evaluacion: function (nuevo, anterior) {
      if (nuevo.length === 0 && this.numPage !== 1) {
        this.numPage = 1;
      }
    },
  },
  async created() {
    await this.init();

    this.puedeModificarLey =
      this.esFaseActivaUsuario &&
      this.fasesRh.includes(this.faseActual) &&
      this.$route.name.includes("aprobacion-solicitud");

    this.puedeModificarUnidad =
      this.esFaseActivaUsuario &&
      this.fasesUnidad.includes(this.faseActual) &&
      !this.$route.name.includes("aprobacion-solicitud");

    this.isView =
      !this.esFaseActivaUsuario &&
      (this.fasesRh.includes(this.faseActual) ||
        this.fasesUnidad.includes(this.faseActual));
  }
};
</script>

<style scoped lang="scss"></style>

<style scoped>
.inputNumber >>> input[type="number"] {
  appearance: textfield;
  -moz-appearance: textfield;
}

.inputNumber >>> input::-webkit-outer-spin-button,
.inputNumber >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

:deep(tbody tr:nth-of-type(odd)) {
  background-color: #eeeeee;
}

/* Alineamiento dinámico de headers */
:deep(.v-data-table > .v-data-table__wrapper > table > thead > tr > th.header-align-center) {
  text-align: center !important;
}

:deep(.v-data-table > .v-data-table__wrapper > table > thead > tr > th.header-align-start) {
  text-align: start !important;
}

:deep(.v-data-table > .v-data-table__wrapper > table > thead > tr > th.header-align-end) {
  text-align: end !important;
}
</style>
